import React from 'react';

const NoDataOverlay: React.FC = () => {
  return <div style={{ padding: '10px', textAlign: 'center' }}>No rows to show</div>;
};

export default NoDataOverlay;
